export const trimDomains = (domains: string) => {
  return domains
    .replaceAll("\n", " ")
    .split(" ")
    .map((domain: string) => domain.replace(",", "").trim())
    .filter((str) => str);
};
